export abstract class BaseModalComponent {
  abstract close(data?: { status: boolean }): void;
  abstract didDismiss(): void;
}